import { NotificationState } from '../types';
import {
  SHOW_NOTIFICATION,
  HIDE_NOTIFICATION,
  NotificationActions,
} from '../actions/types';
import { createReducer } from '../../utils/createReducer';

const initialNotificationState: NotificationState = {
  message: '',
  type: 'info',
  visible: false,
};

export const notificationReducer = {
  [SHOW_NOTIFICATION]: (state: NotificationState, { payload }) => ({
    ...state,
    message: payload.message,
    type: payload.type,
    visible: true,
  }),
  [HIDE_NOTIFICATION]: (state: NotificationState) => ({
    ...state,
    visible: false,
  }),
};

export default (state: NotificationState = initialNotificationState, action: NotificationActions) => createReducer(notificationReducer, state, action);
